import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog zum Speichern der Messungen unter einem Dateinamen.
 * .json wird automatisch angehängt.
 */
function SaveDialog({ open, fileName, onFileNameChange, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && (fileName || '').trim()) {
      e.preventDefault();
      onConfirm();
    }
  };

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{t('dialog.save.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <div className="edit-field">
            <label>{t('dialog.save.filename')}</label>
            <input
              type="text"
              value={fileName}
              onChange={(e) => onFileNameChange(e.target.value)}
              onKeyDown={handleKeyDown}
              className="edit-input"
              placeholder={t('dialog.save.placeholder')}
              autoFocus
            />
            <div style={{ marginTop: '8px', fontSize: '0.85rem', color: '#6b7280' }}>
              {t('dialog.save.hint')}
            </div>
          </div>
        </div>
        <div className="edit-actions">
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            disabled={!(fileName || '').trim()}
            title={t('dialog.save.button_title')}
            type="button"
          >
            {t('dialog.save.button')}
          </button>
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            title={t('dialog.save.cancel_title')}
            type="button"
          >
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SaveDialog;
